import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import {
  Container, Row, Card, CardBody, Col, Button, ButtonToolbar 
} from 'reactstrap';
import { Field, reduxForm } from "redux-form";
import Modal from "../../../../shared/modal";
import * as validate from "../../../../shared/validate";
import * as settings from "../../../../shared/service/settings";

class OnVerify extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    balance: '',
    trashholder: '',
    alert_channel: '',
    show: false,
    errors: [],
    success: ''
  };

  componentDidMount() {
    this.getOnVerifySettings();
  }

  getOnVerifySettings = () => {
    settings.getOnVerify().then(response => {
      this.setState(response);
      this.props.initialize(response);
    });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.initialize(this.state);
    });
  };

  save = () => {
    let errors = [];

    if (!validate.required(this.state.balance)) {
      errors.push(['Balance is required.']);
    } else if (!validate.number(this.state.balance)) {
      errors.push(['Balance must be a valid number.']);
    } else if (this.state.balance < 0) {
      errors.push(['Balance must be a valid positive number.']);
    }

    if (!validate.required(this.state.trashholder)) {
      errors.push(['Trashholder is required.']);
    } else if (!validate.number(this.state.trashholder)) {
      errors.push(['Trashholder must be a valid number.']);
    } else if (this.state.trashholder < 0) {
      errors.push(['Trashholder must be a valid positive number.']);
    } else if (this.state.trashholder > this.state.balance) {
      errors.push(['Trashholder can\'t be greater than balance.']);
    }

    // if (!validate.required(this.state.alert_channel)) {
    //   errors.push(['Alert Channel is required.']);
    // } else if (!validate.url(this.state.alert_channel)) {
    //   errors.push(['Alert Channel must be a valid url.']);
    // }

    if (errors.length > 0) {
      this.setState({
        show: true,
        success: '',
        errors: errors
      });
    } else {
      settings.updateOnVerify({
        balance: this.state.balance,
        trashholder: this.state.trashholder,
        // alert_channel: this.state.alert_channel
      }).then(response => {
        this.setState({
          show: true,
          success: 'On verify settings has been updated successfully.',
          errors: []
        });
      }, (error) => {
        this.setState({
          show: true,
          errors: error._user_message,
          success: "",
        });
      });
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Container>
        <Row className="user-section">
          <Card className="table-section form">
            <CardBody>
              <div className="card__title">
                <h5 className="bold-text">On Verify Settings</h5>                
              </div>
              <Col md={12} lg={12}>
                <form autoComplete="off" className="form form--horizontal" onSubmit={handleSubmit}>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      Balance *
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="balance"
                        component="input"
                        type="text"
                        placeholder="0.00"
                        onKeyUp={this.formChangeHandler}
                        />
                    </div>
                  </div>
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                      Trashholder *
                    </span>
                    <div className="form__form-group-field">
                      <Field
                        name="trashholder"
                        component="input"
                        type="text"
                        placeholder="0.00"
                        onKeyUp={this.formChangeHandler}
                        />
                    </div>
                  </div>
                  {/* <div className="form__form-group">
                    <span className="form__form-group-label">
                    Alert Channel *
                    </span>
                    <div className="form__form-group-field">
                      <Field
                      name="alert_channel"
                      component="input"
                      type="text"
                      placeholder="http:// or https://"
                      onKeyUp={this.formChangeHandler}
                      />
                    </div>
                  </div> */}
                  <div className="form__form-group">
                    <span className="form__form-group-label">
                    
                    </span>
                    <div className="form__form-group-field">
                      <ButtonToolbar className="form__button-toolbar-bkp">
                        <Button color="primary" type="button" onClick={this.save}>
                          Update
                        </Button>
                      </ButtonToolbar>
                    </div>
                  </div>
                </form>
                <Modal
                  onClose={() => this.setState({ show: false })}
                  show={this.state.show}
                  errors={this.state.errors}
                  success={this.state.success}
                ></Modal>
              </Col>
            </CardBody>
          </Card>
        </Row>
      </Container>
    );
  }
}

export default reduxForm({
  form: "onverify_settings_form", // a unique identifier for this form
})(OnVerify);